import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

/** Text-only brand residual until design assets land (external-deps). */
export function BrandHeader({ homeTo = '/' }: { homeTo?: string }) {
  return (
    <header className="border-b border-slate-200 bg-[var(--brand-navy)] text-white">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-between gap-3 px-4 py-4">
        <Link to={homeTo} className="group block no-underline">
          <div className="text-xl font-semibold tracking-tight text-white group-hover:text-[var(--brand-gold)]">
            SuretySwap
          </div>
          <div className="text-xs font-medium uppercase tracking-wider text-slate-300">
            Applied Surety Underwriters
          </div>
        </Link>
      </div>
    </header>
  )
}

export function BrandFooter() {
  return (
    <footer className="mt-auto border-t border-slate-200 bg-white">
      <div className="mx-auto max-w-5xl px-4 py-4 text-center text-sm text-slate-500">
        Powered by Surety Labs
      </div>
    </footer>
  )
}

export function PageShell({
  children,
  homeTo = '/',
}: {
  children: ReactNode
  homeTo?: string
}) {
  return (
    <div className="flex min-h-screen flex-col">
      <BrandHeader homeTo={homeTo} />
      <main className="mx-auto w-full max-w-5xl flex-1 px-4 py-6">{children}</main>
      <BrandFooter />
    </div>
  )
}
